import React, { useEffect, useState } from "react";
import axios from 'axios';
import CandidateNavbar from '../Candidate Navbar/Navbar';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faLocationDot } from '@fortawesome/free-solid-svg-icons'
import {   faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import {   faBuilding } from '@fortawesome/free-solid-svg-icons'
import {   faClock } from '@fortawesome/free-solid-svg-icons'
import "./Candidate_Company_list.css"
import DataTable  from 'react-data-table-component';
import Moment from 'react-moment';
import moment from "moment";
import { toast } from 'react-toastify';
import AppliedCompanies from "./AppliedCompanies";

export default function CandidateCompanylist() {
    const location = useLocation();
    const navigate = useNavigate();
    const [job_list, setJob_List] = useState([])
    const [applyMsg, setApplyMsg] = useState('');
    const [add_company, setadd_company] = useState([]);
    const [showBtn, setShowBtn] = useState(true);
    const [filterText, setFilterText] = useState(''); //for search purpose
    const [validateModal, setvalidateModal] = useState(false);
    const [validatepopupshow, setValidatepopupshow] = useState(false);
    const [appliedCompanies,  setappliedCompanies] = useState(null);

    const user = localStorage.getItem("user");
    let userId = user && JSON.parse(user)[0].id; 
    const selectedItem = location.state.selectedItem;
    let jobFairId = selectedItem && selectedItem.id;

// ====================== This api is for getting job list ======================
    useEffect(() => {
        const user = localStorage.getItem("user");
        if(user === null){
            localStorage.removeItem("user");
            navigate('/Candidate_Login');
        }
        else{
            axios.get(`https://pl.aspireitacademy.com/jobfaircompany_list/${jobFairId}`).then((res) => {
                setJob_List(res.data);
            });

            // check expired
            var todayDate  = new Date();
            if(todayDate > new Date(selectedItem.registration_enddate)){
                setShowBtn(false);
                setApplyMsg("Online Registration Expired. You can apply through spot registration")
            }
        }
    }, []);




   // ========== This functionality is for add company in applied list ==========
   function select_company(item, index) {
    if (add_company.length < 4) {
        setadd_company([...add_company, item]);

      let myArray = job_list.filter(function( obj ) {
        return obj.id !== item.id;
      });

       // job_list.splice(index, 1);
        setJob_List(myArray);
        setApplyMsg(null);
    }
    else {
        setApplyMsg('Sorry, Only 4 companies can be apply');
    }
}

 // ========== This functionality is for remove company in applied list ==========
 function remove_func(item, index) {
    let temp = [...add_company];
    temp.splice(index, 1);
    setadd_company(temp);
    job_list.splice(index, 0, item);
    setJob_List(job_list);
    setApplyMsg(null);
}

    // ========== This functionality is for apply job ==========
var compandId = [];
add_company.map((item) => {
    let obj = { "id": item.id }
    compandId.push(obj)
})

function apply_func() {
    if(add_company.length < 1){
        setApplyMsg("Please Select atleast one company")
    }
    else{
    axios.post(`https://pl.aspireitacademy.com/jobseekercompany_add/${userId}`, compandId).then(res => {
        if (res.data==="Company Applied"){
            
            setShowBtn(false);
            setApplyMsg("Companies added successfully")
        }
        else if(res.data.AppliedCompanies !== undefined ){
            setvalidateModal(true);
            setValidatepopupshow(true);
            setappliedCompanies(res.data.AppliedCompanies);
        }
        else {
            toast.error("Something went wrong"); 
        }
    })}
}


   // ====================== This api is getting data of applied job list ======================
   useEffect(() => {
    axios.post(`https://pl.aspireitacademy.com/jobseekercompany_list/${userId}`, { "jobfairid": jobFairId }).then(res => {
        if (res.data.length > 0) {
            setadd_company(res.data)
            setShowBtn(false)
            setApplyMsg("You already applied for these Companies")
        }

    })
}, []);


// function convertTo12Hour(time24) {
//     let hour = parseInt(time24.substr(0, 2));
//     let minute = time24.substr(3, 2);
//     let ampm = hour >= 12 ? 'PM' : 'AM';
//     hour = hour % 12;
//     hour = hour ? hour : 12;
//     return hour + ':' + minute + ' ' + ampm;
//     }
function convertTo12Hour(time24) {
    const momentTime = moment(time24, "HH:mm");
    const formattedTime = momentTime.format("h:mm A");
    return formattedTime;
}

//Data table structure
const customStyles = {
    headRow: {
      style: {
        color:'#fff',
        backgroundColor: '#a7a7c1',
        fontSize:"13px"
      },
    },
    rows: {
      style: {
        color: "#000",
        backgroundColor: "#fff"
      }
    },
    // cells: {
    //     style: {
    //        margin: '0px', // override the cell padding for data cells
    //         paddingRight: '0px',
    //     },
    // },
    
  }

const columns = [
    {
        name: 'No',
        selector: row => row.no,
        width:"50px",
      
       
       
    },
    {
        name: 'Company Name',
        selector: row => row.cmpname,
        sortable: true,
        grow:4,
       
        
    },
    {
        name: 'Job Description',
        selector: row => row.jobdesc,
        sortable: true,
        grow:3,
       
        
    },
    {
        name: 'Qualification',
        selector: row => row.qualfctn,
        sortable: true,
        grow:3,
       
    },
    {
        name: 'Vacancy',
        selector: row => row.vacancy,
        sortable: true,
        width:"100px",
        
        
    },
    {
        name: 'Select',
        selector: row => row.addcolmn,
        width:"90px",
        omit: showBtn ? false:true,
       
    },
   
];


const rows = job_list?job_list.filter(
    item => (item.CompanyName && item.CompanyName.toLowerCase().includes(filterText.toLowerCase())) ||
          (item.qualification && item.qualification.toLowerCase().includes(filterText.toLowerCase())) ||
          (item.description && item.description.toLowerCase().includes(filterText.toLowerCase()))
).map((item,index) => {
    
    return {
        no : index+1 ,
        cmpname:<span title={item.CompanyName}>{item.CompanyName}</span>,
        jobdesc:<span title={item.description}>{item.description}</span>,
        qualfctn:<span title={item.qualification}>{item.qualification}</span>,
        vacancy:parseInt(item.vacancy),
        addcolmn: showBtn ?<button  id="add-btn" 
                            type={"button"} 
                             onClick={() => select_company(item, index)}  
                             className="btn btn-primary  text-center" >Add
                 </button>:''
        ,
       
       
    }
}):''

// modal close 
const handleValidatePopupClose = () => {
    setvalidateModal(false);
    setValidatepopupshow(false);
  }

   return (
    <>

    {validateModal && < AppliedCompanies
            handleClick={handleValidatePopupClose}
            validatepopupshow={validatepopupshow}
            appliedList = {appliedCompanies}
    />}
    <section style={{backgroundColor:"#f7f5f5"}}>
    <CandidateNavbar />
    <div className="container">
{/* Job fair details start */}
    <div className="job-fair-details bg-white my-4 p-4 w-100" >
            <h2 className="job-fair-title text-capitalize">{selectedItem.title}</h2>
            <p className="card-text  mb-3 text-muted" style={{fontSize:'14px',lineHeight: '1.8'}}>
                        {selectedItem.Description}</p>
            <p className="card-text  mb-3"><FontAwesomeIcon icon={faLocationDot} className="jobfair-icons"/>
                    <span className="ms-2 text-capitalize">{selectedItem.venue}</span></p>
            <p className="card-text mb-3"><FontAwesomeIcon icon={faCalendarDays} className="jobfair-icons"/> 
            <span className="ms-2">Last date to apply:  
                  <Moment date={selectedItem.registration_enddate}format="DD/MM/YYYY"  />
            </span></p>
            <p className="card-text mb-3"><FontAwesomeIcon icon={faCalendarDays} className="jobfair-icons"/> 
            <span className="ms-2">
                     < Moment date={selectedItem.jobfair_startdate} format="DD/MM/YYYY"/> 
                     <span className="mx-1">to </span>
                     < Moment date={selectedItem.jobfair_enddate} format="DD/MM/YYYY"  /></span>
              <span className="mx-2">|</span> <FontAwesomeIcon icon={faClock} className="jobfair-icons"/>
              <span className="ms-2">
                {convertTo12Hour(selectedItem.jobfair_starttime)+ " to "+ convertTo12Hour(selectedItem.jobfair_endtime)}</span>
            </p>
            <p className="card-text mb-2"><FontAwesomeIcon icon={faBuilding} className="jobfair-icons"/> 
            <span className="ms-2">Total no. of Companies: {selectedItem.total_companies}</span></p>	
     </div>  
 {/* job fair details end     */}

    <div className="job-select-container " >
        {/* Search start     */}
                <div className="container p-0  col-md-4 m-0 text-left" >
                        <div className="p-0 my-4">
                            <input type="search"
                            className="form-control me-3 w-100 search-input" 
                            placeholder="Search"
                            onChange={(e)=>{setFilterText(e.target.value)}} 
                            value={filterText}/>
                        
                        </div>           
                </div>
        {/* Search end     */}
    <div className="row" >
          <div className='col-lg-7' >
          <div className="table-responsive mb-3" >
                <DataTable
                    columns={columns}
                    data={rows} 
                    fixedHeader ={true} 
                    fixedHeaderScrollHeight="600px"
                    striped
                    customStyles={customStyles}  
                    persistTableHead

                />


         </div>

          </div>
{/* applied table start */}
        <div className="col-lg-5 text-center "  >
                <div className="container p-3" id="applied-job-container">
                   <h5 className='text-center text-capitalize p-2'>Applied Jobs</h5>
                        <table className="table table-bordered table-hover align-middle">
                            <thead>
                                <tr style={{backgroundColor:"#5ababd",color:'#fff'}}>
                                    <th scope="col" className=" text-nowrap ">Company Name</th>
                                    <th scope="col" className="text-nowrap">Job Description</th>
                                    {showBtn ? <th scope="col" className="text-nowrap"></th>:""}
                                </tr>
                            </thead>
                            <tbody>
                            {add_company.map((item, index) =>
                                    <tr key={item.id}>
                                        <td >{item.CompanyName}</td>
                                        <td >{item.description}</td>
                                        
                                        <td style={{ display : showBtn ? '':'none'}}
                                        
                                        
                                        >
                                        {showBtn ? <input id="job-remove-btn" 
                                                        type={"button"} 
                                                        onClick={() => remove_func(item, index)} 
                                                        value={"Remove"} 
                                                        className="btn btn-danger" /> : null}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {applyMsg? 
                        <p 
                       
                       
                        className={ applyMsg=== "Companies added successfully" ? "alert alert-success":
                                        "alert alert-danger"}
                        style={{padding: "8px"}}>{applyMsg}</p>: ""}
                         {showBtn ? <button type="button"
                             id="job-apply-btn" 
                             onClick={() => apply_func()} 
                             className="btn btn-success">Apply</button> : null}
       
                </div>
            </div>
{/* applied table End */}



    </div>

        
    </div>






    </div>
    </section>
    </>
   )
}